// extracted by mini-css-extract-plugin
export var chevronIcon = "_4k-2";
export var teamName = "_4k-1";
export var teamSwitcherButton = "_4k-0";